import * as React from 'react';
// mui
import {
  Card,
  CardContent,
  CardHeader,
  Grid,
  Typography,
  useMediaQuery,
  useTheme,
  Box
} from '@mui/material';
// components
import AuthCard from '../../components/AuthPage/AuthCard';

export default function AuthPage() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  
  return (
    <Box
      sx={{
        minHeight: '100vh',
        background: (theme) =>
          `linear-gradient(to bottom right, 
        ${theme.palette.primary.main}44 0%, 
        ${theme.palette.background.default}FF 100%)`
      }}
    >
      <Grid container sx={{ p: 4 }} spacing={4}>
        <Grid size={isMobile ? 12 : 6}>
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            minHeight={ isMobile ? '' : 'calc(100vh - 64px)' }
          >
            <Card sx={{ width: 500, p: 2 }}>
              <CardHeader
                title="Welcome to the Task Manager Alpha"
                subheader="Please register with your alpha test key, or login to continue."
              />
              <CardContent>
                <Typography>If you encounter any <span style={{ color: '#556cd6' }}>bugs</span>, please report them using the meny item on the left hand side within the app.</Typography>
                <br />
                <Typography>Any and all <span style={{ color: '#556cd6' }}>suggestions, recommendations or ideas</span> are greatly apreciated. You can submit them easily using the suggestion menu item found next to the bug report menu item.</Typography>
              </CardContent>
            </Card>
          </Box>
        </Grid>

        <Grid size={isMobile ? 12 : 6}>
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            minHeight={ isMobile ? '' : 'calc(100vh - 64px)' }
          >
            <AuthCard />
          </Box>
        </Grid>
      </Grid>
    </Box>
  )
}
